module.exports = __webpack_public_path__ + "img/ic_help_outline.dc412fdf.svg";